import builder from '../builder';
import AccountingDocument from '../../streamline-icons/light/accounting-document.svg';

export default builder('IconAccountingDocumentLight', AccountingDocument);
